import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
export const useNamespaceTranslations = _ref => {
  let {
    i18n,
    resources,
    namespace = 'translation',
    ...props
  } = _ref;
  const locale = i18n.options.lng ?? 'en';
  if (resources && !i18n.hasResourceBundle(locale, namespace)) {
    i18n.addResourceBundle(locale, namespace, resources, true, false);
  }
  const Trans = props_ => /*#__PURE__*/React.createElement(props.Trans, _extends({
    ns: namespace,
    i18n: i18n
  }, props_));
  const t = React.useCallback(function (key, options) {
    if (options === void 0) {
      options = {};
    }
    return i18n.t(key, {
      ...i18n.options,
      ns: namespace,
      ...options
    });
  }, [i18n]);
  return {
    t,
    i18n,
    Trans,
    locale
  };
};
//# sourceMappingURL=useNamespaceTranslations.js.map